module.exports = __webpack_public_path__ + "static/img/device_s4_max.8bb7e14f.png";